export default __webpack_public_path__ + "static/media/money.554cc5ef.svg";